(() => {
  if (!customElements.get('phone-sheet'))
    customElements.define(
      'phone-sheet',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;
          this.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('[data-sheet-open]')) this.open(event.detail === 0);
              if (event.target.closest('[data-sheet-close]') || event.target === this.dialog) this.close();
            },
            options,
          );
          this.dialog.addEventListener(
            'cancel',
            (event) => {
              event.preventDefault();
              this.close(true);
            },
            options,
          );
          this.querySelector('[data-spec-filter]')?.addEventListener(
            'input',
            (event) => {
              const q = event.target.value.trim().toLocaleLowerCase();
              let matches = 0;
              this.querySelectorAll('[data-spec-row]').forEach((row) => {
                row.hidden = !row.textContent.toLocaleLowerCase().includes(q);
                if (!row.hidden) matches++;
              });
              const empty = this.querySelector('[data-spec-empty]');
              if (empty) empty.hidden = matches > 0;
            },
            options,
          );
          this.addEventListener('shopify:block:select', () => this.open(true), options);
          this.addEventListener('shopify:block:deselect', () => this.close(), options);
        }
        disconnectedCallback() {
          this.paintTicket = (this.paintTicket || 0) + 1;
          cancelAnimationFrame(this.openFrame);
          clearTimeout(this.closeTimer);
          this.controller?.abort();
          this.dialog?.close();
          this.restoreScroll();
        }
        restoreScroll() {
          if (this.scrollLocked) {
            document.documentElement.style.overflow = this.previousOverflow;
            this.scrollLocked = false;
          }
        }
        open(keyboard = false) {
          if (!this.dialog) return;
          clearTimeout(this.closeTimer);
          cancelAnimationFrame(this.openFrame);
          if (this.dialog.open) {
            this.dialog.classList.add('is-open');
            return;
          }
          this.dialog.classList.toggle('phone-sheet--instant', keyboard);
          this.dialog.showModal();
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.scrollLocked = true;
          const ticket = (this.paintTicket = (this.paintTicket || 0) + 1);
          this.dialog.classList.remove('is-open');
          this.dialog.querySelector('.phone-sheet-panel')?.getBoundingClientRect();
          this.openFrame = requestAnimationFrame(() => {
            this.openFrame = requestAnimationFrame(() => {
              if (this.dialog.open && this.paintTicket === ticket) this.dialog.classList.add('is-open');
            });
          });
        }
        close(keyboard = false) {
          if (!this.dialog?.open) return;
          this.paintTicket = (this.paintTicket || 0) + 1;
          cancelAnimationFrame(this.openFrame);
          this.dialog.classList.remove('is-open');
          const finish = () => {
            this.dialog.close();
            this.restoreScroll();
          };
          // Native focus restoration remains intact; keyboard exits are instant.
          if (
            keyboard ||
            this.dialog.classList.contains('phone-sheet--instant') ||
            matchMedia('(prefers-reduced-motion: reduce)').matches
          )
            finish();
          else {
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(finish, 230);
          }
        }
      },
    );
  if (!customElements.get('phone-inspection'))
    customElements.define(
      'phone-inspection',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          this.addEventListener(
            'toggle',
            (event) => {
              if (!event.target.matches('details') || !event.target.open) return;
              this.querySelectorAll('details[open]').forEach((item) => {
                if (item !== event.target) item.open = false;
              });
              this.querySelectorAll('[data-inspection-visual]').forEach((visual) => {
                visual.hidden = visual.dataset.inspectionVisual !== event.target.dataset.inspectionBlock;
              });
            },
            { capture: true, signal: this.controller.signal },
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const item = event.target.closest('details');
              if (item) item.open = true;
            },
            { signal: this.controller.signal },
          );
        }
        disconnectedCallback() {
          this.controller?.abort();
        }
      },
    );
})();
